module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.agenda.creationUser) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-flag",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Criada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.agenda.creationUser.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("no dia")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("em " + _vm._s(_vm._f("date")(_vm.agenda.creationDateTime, 'DD/MM/YYYY HH:mm:ss')))])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.agenda.updateUserLog) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Editada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, _vm._l((_vm.agenda.updateUserLog), function(log) {
    return (log.schoolUser && log.dateTime) ? _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(log.schoolUser.name) + "\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("em " + _vm._s(_vm._f("date")(log.dateTime, 'DD/MM/YYYY HH:mm:ss')))])]) : _vm._e()
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.agenda.publishedUser) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('popover', {
    attrs: {
      "placement": "right",
      "width": "350",
      "trigger": "hover"
    }
  }, [_c('button', {
    staticClass: "btn btn-circle grey-salsa btn-outline btn-sm",
    attrs: {
      "slot": "reference",
      "type": "button"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Publicada por...")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group m-b-0"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('strong', [_vm._v(_vm._s(_vm.agenda.publishedUser.name))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("no dia")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("em " + _vm._s(_vm._f("date")(_vm.agenda.publishedDateTime, 'DD/MM/YYYY HH:mm')))])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a3c9d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/agenda-editors/agenda-editors.vue
// module id = 1079
// module chunks = 1